import { useState } from 'react';
import MapOutlined from '@mui/icons-material/MapOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleFullScreenButton,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleGlobalFilterButton,
  MRT_GlobalFilterTextField
} from 'material-react-table';
import TableDownloadButton from './TableDownloadButton';
import SpringfieldTop100 from '../springfieldtop100.geojson'
import ChicagoTop100 from '../chicagotop100.geojson'


import { getDefaultMRTOptions, TABLE_COLS, fetcher, aggregationCols, isArrayNonEmptySubset, MONITORED_ROAD_COLS, GEOGRAPHIES_DEFAULT } from '../constants';
import useSWR from 'swr';
import { FormControl, InputLabel, NativeSelect, OutlinedInput, Snackbar } from '@mui/material';

const categoryAggregationMap = new Map([
  ['counties', 'County'],
  ['mpos', 'MPO'],
  ['districts', 'District'],
  ['regions', 'Region'],
  // ['State', 'State']
])

export default function MonitoredRoadsTable(
  { data, showOnMapData, setShowOnMapData, year, layer }
) {
  const layerOptionName = layer !== '' ? GEOGRAPHIES_DEFAULT.mpos[layer] : ''
  const { data: mapData, error: mapDataError } = useSWR(
      (['Chicago', 'Springfield'].includes(layerOptionName) && year === '2021')
          ? `${window.location.origin}${layerOptionName === 'Chicago' ? ChicagoTop100 : ''}${layerOptionName === 'Springfield' ? SpringfieldTop100 : ''}`
          : null,
      
      async (urlKey) => {
        const res = await fetch(urlKey)
        if (res.ok) {
          const newJSON = await res.json()
          return newJSON
        } else {
          throw new Error('data fetching failed')
        }
      },
      {
        fallbackData: [],
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        shouldRetryOnError: false,
      },
  )

  const table = useMaterialReactTable({
    ...getDefaultMRTOptions,
    columns: MONITORED_ROAD_COLS,
    data: mapData?.features ?? [],
    initialState: {
      columnOrder: [
        'roadname',
        ...MONITORED_ROAD_COLS.map(d => d.id).filter(d => d !== 'roadname')
      ]
    },
    renderRowActions: ({row}) => (
      <Tooltip title={showOnMapData.includes(row.original.properties.top100id) ? 'Undo' : 'Show on map'} placement='right'>
        <IconButton
          color='inherit'
          onClick={() => {
            if (showOnMapData.includes(row.original.properties.top100id)) {
              setShowOnMapData(prev => prev.filter(p => p !== row.original.properties.top100id))
            } else {
              setShowOnMapData(prev => [...prev, row.original.properties.top100id])
            }
          }}
        >
          <MapOutlined />
        </IconButton>
      </Tooltip>
    ),
    renderTopToolbar: ({table}) => (
      <div style={{paddingTop: 15, paddingBottom: 15, display: 'flex', alignItems: 'center', height: '7vh'}}>
        <MRT_ToggleFiltersButton table={table} />
        <MRT_ShowHideColumnsButton table={table} />
        <MRT_ToggleDensePaddingButton table={table} />
        <MRT_ToggleFullScreenButton table={table} />
        {/* <TableDownloadButton table={table} category={category} /> */}
        <MRT_ToggleGlobalFilterButton table={table} />
        <MRT_GlobalFilterTextField table={table} />
      </div>
    ),
    muiTableBodyRowProps: ({row}) => ({
      sx: (theme) => ({
        '& td': {
          color: showOnMapData.includes(row.original.properties.top100id) ? 'red' : theme.palette.text.primary,
          fontWeight: showOnMapData.includes(row.original.properties.top100id) ? 'bold' : 'normal',
          borderLeft: '1px solid ' + theme.palette.divider,
          borderRight: '1px solid ' + theme.palette.divider,
        }
      })
    }),
    muiTablePaperProps: {
      id: 'ILMAT_Monitored_Roads'
    },
  });

  return <MaterialReactTable table={table} />;

}